import React from "react";
import {Garage} from "@App/types";
import {GarageProfileExpertise} from "@App/components/GarageProfile/GaragProfileParts/GarageProfileExpertise";
import {icons} from "@App/icons";
import {Text} from "@eo-locale/react";

export type GarageProfileOfferingsProps = {
    garage: Garage
};

export const GarageProfileOfferings = React.memo<GarageProfileOfferingsProps> (({garage}) => {

    return (
        <div className={'garageProfile__offerings col-span-full mb-10'}>
            <h2 className={'text-2xl md:text-3xl font-serif mb-8 text-gray-900'}><Text id={'garage_offerings'}/></h2>
            {garage.supports_bev && (
                <GarageProfileExpertise/>
            )}
            <h3 className={'text-lg font-semibold font-serif mb-3'}><Text id={'services'}/></h3>
                <ul className={'grid grid-cols-2 mb-1'}>
                    {garage.availableServices && garage.availableServices.map((service, index) => (
                            <li className={'col-span-2 md:col-span-1 mb-3 flex items-center'} key={service.id}>
                                <i className={`fa-kit fa-fw text-primary text-2xl fa-${icons[service.icon as keyof typeof icons]} align-middle mr-3 relative`}></i>{service.name}
                            </li>
                        )
                    )}
                </ul>
        </div>
    )
})

GarageProfileOfferings.displayName = 'GarageProfileOfferings';
